export const image_size_qpt = [
    {
        image_name: 'low_r',
        width_image: 100,
        height_image: 140
    },
    {
        image_name: 'moderate_r',
        width_image: 240,
        height_image: 140
    },
    {
        image_name: 'high_r',
        width_image: 365,
        height_image: 140
    }
]

export const text_config = [
    {
        // Allergy & Eczema
        page: 16,
        value_comparing: [
            'Asthma',
            'Food allergy',
            'Eczema',
            'Allergic rhinitis'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['Based on your gut microbiome, you have a low risk ','of developing allergies, eczema and respiratory sensitivities.'], 
                img: 'low_r',
                posX_image: 130,
                posY_image: 360,
                posX_text: 237,
                posY_text: 405,
                fontFamily: '"Gilroy-Regular", sans-serif',

                label_2: ['Your current gut microbiota profile suggests a low risk of developing ','immune-mediated conditions such as allergies, eczema, and respiratory sensitivities.'],
                Xlabel_2: 50,
                Ylabel_2: 273,
                fontFamily_label_2: '"Gilroy-Regular", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['Based on your gut microbiome, you have a moderate risk ','of developing allergies, eczema and respiratory sensitivities.'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 360,
                posX_text: 300,
                posY_text: 404,
                fontFamily: '"Gilroy-Regular", sans-serif',

                label_2: ['Your current gut microbiota profile suggests a moderate risk of developing ','immune-mediated conditions such as allergies, eczema, and respiratory ','sensitivities.'],
                Xlabel_2: 50,
                Ylabel_2: 273,
                fontFamily_label_2: '"Gilroy-Regular", sans-serif'
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f', 
                label: ['Based on your gut microbiome, you have a', 'high risk of developing allergies, eczema and', 'respiratory sensitivities.'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 360,
                posX_text: 427,
                posY_text: 385,
                fontFamily: '"Gilroy-Regular", sans-serif',

                label_2: ['Your current gut microbiota profile suggests a high risk of developing ','immune-mediated conditions such as allergies, eczema, and respiratory ','sensitivities.'],
                Xlabel_2: 50,
                Ylabel_2: 273,
                fontFamily_label_2: '"Gilroy-Regular", sans-serif'
            }
        ]
    },
    {
        // Obesity & Metabolic Syndrome
        page: 21,
        value_comparing: [
            'Overweight',
            'Metabolic syndrome',
            'Type 2 diabetes',
            'Excessive lipopolysaccharide'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['Based on your gut microbiome, you have a low risk ','of developing obesity and metabolic syndrome.'], 
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 237,
                posY_text: 270,
                fontFamily: '"Gilroy-Regular", sans-serif',

                label_2: ['Your results suggest a low risk in microbial populations tied to body weight ', 'regulation and metabolic efficiency'],
                Xlabel_2: 50,
                Ylabel_2: 150,
                fontFamily_label_2: '"Gilroy-Regular", sans-serif'
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['Based on your gut microbiome, you have',' a moderate risk of developing obesity and metabolic syndrome.'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 270,

                label_2: ['Your results suggest a high moderate in microbial populations tied to body weight ', 'regulation and metabolic efficiency'],
                Xlabel_2: 50,
                Ylabel_2: 150
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f',
                label: ['Based on your gut microbiome, you have a', 'high risk of developing obesity and', 'metabolic syndrome.'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 427,
                posY_text: 255,

                label_2: ['Your results suggest a high risk in microbial populations tied to body weight ', 'regulation and metabolic efficiency'],
                Xlabel_2: 50,
                Ylabel_2: 150
            }
        ]
    },
    {
        // Intestinal Disease
        page: 29,
        value_comparing: [
            'Constipation',
            'Diarrhea',
            'Immune disorder'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['Based on your gut microbiome, you have a low risk', ' for gastrointestinal discomfort, particularly constipation,', ' diarrhea and immune irregularities.'], 
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 237,
                posY_text: 255,

                label_2: ['Your current microbial landscape indicates a low risk for gastrointesinal', ' discomfort, particularly constipation, diarrhea and immune irregularities.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['Based on your gut microbiome, you have a moderate risk ','for gastrointestinal discomfort, particularly constipation,',' diarrhea and immune irregularities.'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 255,

                label_2: ['Your current microbial landscape indicates a moderate risk for gastrointesinal', ' discomfort, particularly constipation, diarrhea and immune irregularities.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f', 
                label: ['Based on your gut microbiome, you have a', 'high risk for gastrointestinal discomfort, ','particularly constipation, diarrhea and ','immune irregularities.'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 427,
                posY_text: 235,

                label_2: ['Your current microbial landscape indicates a high risk for gastrointesinal', ' discomfort, particularly constipation, diarrhea and immune irregularities.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            }
        ]
    },
    {
        // Mental Health
        page: 36,
        value_comparing: [
            'Insomnia/ poor sleep quality',
            'Stress and anxiety'
        ],
        mapping_text: [
            {
                min: 0, 
                max: 3, 
                color_dot: '#8bcc2c', 
                label: ['Based on your gut microbiome, you have a low risk symptoms related',' to mood regulation and sleep quality'],
                img: 'low_r',
                posX_image: 130,
                posY_image: 230,
                posX_text: 237,
                posY_text: 275,

                label_2: ['Your results suggest a low vulnerability to symptoms related to mood',' regulation and sleep quality.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            },
            {
                min: 4, 
                max: 6, 
                color_dot: '#fa891f',
                label: ['Based on your gut microbiome, you have a moderate risk',' symptoms related to mood regulation and sleep quality'],
                img: 'moderate_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 300,
                posY_text: 275,

                label_2: ['Your results suggest a moderate vulnerability to symptoms related to mood',' regulation and sleep quality.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            },
            {
                min: 7, 
                max: 100, 
                color_dot: '#fa1f1f', 
                label: ['Based on your gut microbiome,',' you have a high risk symptoms related to',' mood regulation and sleep quality'],
                img: 'high_r',
                posX_image: 50,
                posY_image: 230,
                posX_text: 427,
                posY_text: 255,

                label_2: ['Your results suggest a high vulnerability to symptoms related to mood',' regulation and sleep quality.'],
                Xlabel_2: 50,
                Ylabel_2: 150
            }
        ]
    },
]